import React from 'react'
import { Container } from 'semantic-ui-react';
import InlineSvg from '../InlineSvg';

const SliderControls = (props) => {

const {slides, slideIndex, gotoSlide, playing, time, autoswipetimer, gotoNext, mobile, playState, setPlayState} = props

const timerRef = React.useRef()

React.useEffect(() => {
  if(playState === "paused") {
    timerRef.current.classList.add("pause")
  } else {
    timerRef.current.classList.remove("pause")
  }
}, [playState, playing])

  return (
    <div className={`category-hero-banner__controls-wrapper ${mobile ? "category-hero-banner__controls-mobile" : ""}`}>
    <Container>
      <div className="grid-wrapper">
        <div className="category-hero-banner__controls-container">
          <div className="category-hero-banner__dot-group">
            {slides.map((slideDot, i) => (
              <button
                key={i}
                className={`${
                  i === slideIndex ? 'current-slide' : ''
                } ${'category-hero-banner__btn'}`}
                onClick={() => {
                  gotoSlide(i);
                }}
              >
                {i === slideIndex ? `${i < 9 ? '0' : <span className='category-hero-banner_dot'> </span>}${i + 1}` : <span className='category-hero-banner_dot'> </span>}
              </button>
            ))}
          </div>
          <div className='category-hero-banner__play-pause-wrapper'>
            <button tabIndex="0" aria-label='Play/pause header carousel' className='category-hero-banner__play-pause-btn' onClick={() => {
              if(playState === "paused") {
                setPlayState("play")
              } else {
                setPlayState("paused")
              }
            }}>
              <InlineSvg name={`${playState === 'paused' ? "play-icon" : "pause-icon"}`} />
            </button>
          </div>
          <div className="timer">
            <div
            ref={timerRef}
              className={`time pause ${playing ? 'playing' : ''}`}
              style={{
                width: `${time}%`,
                animation: `${
                  playing
                    ? `timerBar ${autoswipetimer}s ease-out`
                    : 'width 0s 0.5s ease-out, opacity 0.5s ease-out'
                }`,
              }}
              onAnimationEnd={playing ? gotoNext : null}
            ></div>
          </div>
        </div>
      </div>
    </Container>
  </div>
  )
}

export default SliderControls